// Mantiene título, descripción, canonical y robots al navegar dentro de la web (la SPA no recarga el HTML).
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { SEO_BY_PATH, SITE_URL } from '../seo/pages';

const OTHER_TITLES: Record<string, string> = {
  '/privacidad': 'Política de privacidad · Jugaly',
  '/terminos': 'Términos de uso · Jugaly',
  '/aviso-legal': 'Aviso legal · Jugaly',
  '/profile': 'Tu perfil · Jugaly',
  '/auth': 'Entrar · Jugaly',
  '/reset-password': 'Cambiar contraseña · Jugaly',
};

// Páginas privadas o de trámite: que no salgan en Google
const NO_INDEX = new Set(['/profile', '/auth', '/reset-password']);

function setMeta(selector: string, attr: string, value: string, create: () => HTMLElement) {
  let el = document.head.querySelector<HTMLElement>(selector);
  if (!el) { el = create(); document.head.appendChild(el); }
  el.setAttribute(attr, value);
}

export function usePageMeta() {
  const { pathname } = useLocation();
  useEffect(() => {
    const page = SEO_BY_PATH[pathname];
    document.title = page?.title ?? OTHER_TITLES[pathname] ?? 'Jugaly';
    if (page) {
      setMeta('meta[name="description"]', 'content', page.description, () => Object.assign(document.createElement('meta'), { name: 'description' }));
    }
    setMeta('link[rel="canonical"]', 'href', SITE_URL + pathname, () => Object.assign(document.createElement('link'), { rel: 'canonical' }));
    setMeta('meta[name="robots"]', 'content', NO_INDEX.has(pathname) ? 'noindex, follow' : 'index, follow', () => Object.assign(document.createElement('meta'), { name: 'robots' }));
  }, [pathname]);
}
